import { Component, OnInit } from '@angular/core';
import {isFormModifiedDataService, SimpleNavigationService} from '../services/data-services/navigation-data-services';
import { ActivatedRoute, Router } from '@angular/router';
import { SimpleModalService } from 'ngx-simple-modal';
import { ConfirmModalComponent } from '../components/modals/confirm-modal/confirm-modal.component';
import { AuthHelperService } from '../services/auth-helper.service';
import { RoleConstants } from '../constants/roleConstants';
import { ErrorProcessorService } from '../services/error-processor.service';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.sass'],
})
export class SideBarComponent implements OnInit {
  adminRole: string = RoleConstants.Admin;
  tenantAdminRole: string = RoleConstants.TenantAdmin;
  authHelper: AuthHelperService;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _isFormModifiedDataService: isFormModifiedDataService,
    private _modalService: SimpleModalService,
    private errorProcessorService: ErrorProcessorService,
    private _navigationService: SimpleNavigationService,
    authHelper: AuthHelperService
  ) {
    this.authHelper = authHelper;
  }

  ngOnInit(): void {}

  navigateTo(path: string) {
    this._navigationService.navigateTo(path);
  }

  // TODO elég sokszor hívódik meg a háttérben
  isActiveLink(path: string): boolean {
    const activeRoute = this._router.url.split('/')[1];
    return path === activeRoute;
  }
}
